export const VIEW_LESSON_ACTIVITY_RESULT = "VIEW_LESSON_ACTIVITY_RESULT"
export const VIEW_LESSON_ACTIVITY_RESULT_SUCCESS = "VIEW_LESSON_ACTIVITY_RESULT_SUCCESS"
export const VIEW_LESSON_ACTIVITY_RESULT_FAILED = "VIEW_LESSON_ACTIVITY_RESULT_FAILED"